module.exports = {
	"header": "Oops! 500 - Internal server error",
	"goBack": "Go back to main site",
	"ln1": "Sorry... It's not you. It's us.",
	"ln2": "We're experiencing an internal server problem.",
	"ln3": "Please try again or contact <supportEmail>$t(500::supportEmail)</supportEmail>",
	"supportEmail": "support@auctionex.com"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/500.json5
// module id = 1916
// module chunks = 6